import React, { forwardRef } from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import "../Styles/Message.css";

const Message = forwardRef(({ username, message }, ref) => {
  const isUser = username === message.username;

  return (
    <Card
      ref={ref}
      className={`message__container ${
        isUser ? "message_user" : "message_other"
      }`}
    >
      <CardContent>
        <Typography className="messages_text">
          {!isUser &&`${message.username}: `}
          {message.message}
        </Typography>
      </CardContent>
    </Card>
  );
});

export default Message;
